<script lang="ts">
    import { setContext } from 'svelte'
    import { derived as sderived, writable } from 'svelte/store'
    import type { Writable } from 'svelte/store'

    import { Router, type RouteConfig } from '@mateothegreat/svelte5-router'

    import { gettext as _ } from 'hydria/services/gettext'
    import { spath } from 'hydria/svelte_helpers'

    import { GenOrder } from './order'

    import Invoice from './Invoice.svelte'
    import OrderComponent from './Order.svelte'
    import OrderContacts from './OrderContacts.svelte'

    interface Props {
        route: any
    }

    let { route }: Props = $props()

    let _orderId = $derived(route.result.path.params?.id)

    const Order = new GenOrder()
    // svelte-ignore state_referenced_locally
    const orderId: Writable<string> = writable(_orderId)

    setContext(
        'orderId',
        sderived(orderId, (orderId) => orderId),
    )
    setContext('Order', Order)
    $effect(() => {
        $orderId = _orderId
        Order.reset(_orderId)
    })

    const routes: RouteConfig[] = [
        { path: '/', component: OrderComponent },
        { path: '/contacts', component: OrderContacts },
        { path: '/invoice', component: Invoice },
    ]
</script>

<Router {routes} basePath={spath(`/ecom/order/${_orderId}`)} />
